<template>
  <div class="tpl">
    <van-nav-bar title="订单列表" left-text="返回" right-text left-arrow fixed @click-left="onClickLeft" />
    <div style="height:46px"></div>
    <van-tabs v-model="active" @change="tabChange" color="#1baeae" title-active-color="#1baeae" title-inactive-color="#1baeae">
      <van-tab :title="t.title" :name="t.index" v-for="t in tabs" :key="t.index">
        <div class="group" v-for="item in list" :key="item.id" v-on:click="$router.push('/user/orderdetail/'+item.module +'/' + item.id)">
          <div style="display:flex; justify-content:space-between;">
            <div>{{module[item.module]}}  订单编号：{{item.id}}</div>
            <div>{{item.status_str}}</div>
          </div>
          <div class="goods">
            <div class="g" v-for="g in item.details" :key="g.id">
              <div class="l">
                <van-image width="100px" height="100px" fit="contain" :src="GLOBAL.IMG + g.thumb" />
              </div>
              <div class="r">
                <div class="title">{{g.title}}</div>
                <div class="attr_price">
                  <div>{{g.spec}}</div>
                  <div style="color:red">{{g.price}} × {{g.number}}</div>
                </div>
              </div>
            </div>
          </div>
          <div>共{{item.num}}件，总金额：{{item.amount}}</div>
        </div>
      </van-tab>
    </van-tabs>
    <div style="height:60px;"></div>
    <DPtabbar active="4"></DPtabbar>
  </div>
</template>
<script>
import Vue from "vue";
import { Tab, Tabs } from "vant";
import DPtabbar from "@/components/TabBar.vue";
Vue.use(Tab);
Vue.use(Tabs);
export default {
  name: "orderList",
  components: {
    DPtabbar
  },
  data() {
    return {
      tabs: [
        { title: "全部", index: '-1' },
        { title: "待付款", index: '1' },
        { title: "待发货", index: '2' },
        { title: "已发货", index: '3' },
        { title: "交易完成", index: '4' }
      ],
      active: this.$route.params.status, 
      status: this.$route.params.status,
      user: { token: "", user: {} }, // e09a79e47b38941404f8e0372d5f5fa009ec7c1f19759430d403578d126636be
      list: [],
      module: ["", "亿起购", "亿起抢", "亿起团"] //1亿起购，2亿起抢，3亿起团
    };
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    tabChange(name){
        this.status = name;
        this.getList();
    },
    getList() {
      this.$http
        .get(this.GLOBAL.API + "s_user/order/orderList", {
          params: { status: this.status, module: -1, page: 1 },
          headers: { "XX-Token": this.user.token, "XX-Device-Type": "mobile" }
        })
        .then(response => {
          let data = response.body;
          if (data.code == 1) {
            this.list = data.data;
          } else {
            this.$toast(data.msg);
          }
        });
    }
  },
  mounted() {
    if (JSON.parse(localStorage.getItem("user"))) {
      this.user = JSON.parse(localStorage.getItem("user"));
    }
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.tpl {
  height: 100%;
  background-color: #f6f6f6;
  text-align: left;
}
.group {
  background-color: #fff;
  margin: 10px;
  border-radius: 10px;
  padding: 10px;
  .goods {
    .g {
      margin-top: 5px;
      display: flex;
      .l {
        width: 100px;
      }
      .r {
        flex-grow: 1;
        margin-left: 20px;
        .title {
          line-height: 25px;
          height: 50px;
          overflow: hidden;
        }
        .attr_price {
          display: flex;
          justify-content: space-between;
        }
      }
    }
  }
}
</style>